import { collection, CollectionReference, doc, DocumentReference, Firestore, getDocs, Query } from "@angular/fire/firestore";

// export function getCollection<T>(fs: Firestore, dest: string | Query) {
//     let collRef: Query;// = query ?? collection(fs, path);
//     if (typeof dest === 'string')
//         collRef = collection(fs, dest);
//     else
//         collRef = dest;
//     return getDocs(collRef).then(result => result.docs.map(doc => ({ ...doc.data() }))) as Promise<Array<T & { uid: string }>>;
// }

// export function fetchDoc<T>(fs: Firestore, dest: string | DocumentReference) {
//     let docRef: DocumentReference;
//     if (typeof dest === 'string')
//         docRef = doc(fs, dest);
//     else
//         docRef = dest;
//     return getDoc(docRef).then(doc => doc.data() as T);
// }

export function docRef<T>(fs: Firestore, path: string, ...pathSegments: string[]) {
    return doc(fs, path, ...pathSegments) as DocumentReference<T>;
}

export function collectionRef<T>(fs: Firestore, path: string, ...pathSegments: string[]) {
    return collection(fs, path, ...pathSegments) as CollectionReference<T>;
}